var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "p-20" },
    [
      _c(
        "van-form",
        {
          ref: "form",
          attrs: { "show-error": false, "error-message-align": "right" },
        },
        [
          _c(
            "van-cell-group",
            [
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "flowNo",
                    expression: "'flowNo'",
                  },
                ],
                attrs: {
                  required: _vm.isRequired("flowNo"),
                  rules: _vm.getRules("flowNo"),
                  label: "编号",
                  "input-align": "right",
                  readonly: "",
                },
                model: {
                  value: _vm.formData.flowNo,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "flowNo", $$v)
                  },
                  expression: "formData.flowNo",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "yyrq",
                    expression: "'yyrq'",
                  },
                ],
                attrs: {
                  required: _vm.isRequired("yyrq"),
                  name: "yyrq",
                  label: "用印日期",
                  placeholder: "用印日期",
                  "input-align": "right",
                  rules: _vm.getRules("yyrq"),
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("view-item", {
                          attrs: {
                            value: _vm.formData.yyrq,
                            placeholder: "请选择用印日期",
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.isShowPopup(_vm.yyrq, "yyrq")
                            },
                          },
                        }),
                        _c("van-calendar", {
                          ref: "yyrq",
                          attrs: {
                            "min-date": _vm.minDate,
                            "show-confirm": false,
                            title: "选择用印日期",
                          },
                          on: { confirm: _vm.yyrqConfirm },
                          model: {
                            value: _vm.yyrq.show,
                            callback: function ($$v) {
                              _vm.$set(_vm.yyrq, "show", $$v)
                            },
                            expression: "yyrq.show",
                          },
                        }),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.formData.yyrq,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "yyrq", $$v)
                  },
                  expression: "formData.yyrq",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "yywjzl",
                    expression: "'yywjzl'",
                  },
                ],
                attrs: {
                  "input-align": "right",
                  name: "yywjzl",
                  required: _vm.isRequired("yywjzl"),
                  value: _vm.formData.yywjzl,
                  label: "用印文件种类",
                  rules: _vm.getRules("yywjzl"),
                  placeholder: "请选择用印文件种类",
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("view-item", {
                          attrs: {
                            value: _vm.formData.yywjzl,
                            placeholder: "请选择用印文件种类",
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.isShowPopup(_vm.yywjzl, "yywjzl")
                            },
                          },
                        }),
                        _c(
                          "van-popup",
                          {
                            attrs: { position: "bottom" },
                            model: {
                              value: _vm.yywjzl.show,
                              callback: function ($$v) {
                                _vm.$set(_vm.yywjzl, "show", $$v)
                              },
                              expression: "yywjzl.show",
                            },
                          },
                          [
                            _c("van-nav-bar", {
                              attrs: {
                                title: "选择用印文件种类",
                                "left-text": "取消",
                                "right-text": "确定",
                              },
                              on: {
                                "click-left": function ($event) {
                                  _vm.yywjzl.show = false
                                },
                                "click-right": function ($event) {
                                  return _vm.popupSubmit("yywjzl")
                                },
                              },
                            }),
                            _c("van-search", {
                              attrs: { clearable: "", shape: "round" },
                              on: {
                                input: function ($event) {
                                  return _vm.pickerSearch($event, _vm.yywjzl)
                                },
                              },
                              model: {
                                value: _vm.yywjzl.filterText,
                                callback: function ($$v) {
                                  _vm.$set(_vm.yywjzl, "filterText", $$v)
                                },
                                expression: "yywjzl.filterText",
                              },
                            }),
                            _c("van-picker", {
                              ref: "yywjzl",
                              attrs: {
                                "value-key": "label",
                                columns: _vm.yywjzl.filteredData,
                              },
                              on: {
                                cancel: function ($event) {
                                  _vm.yywjzl.show = false
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "wjfs",
                    expression: "'wjfs'",
                  },
                ],
                attrs: {
                  readonly: _vm.isDisabled("wjfs"),
                  type: "number",
                  required: _vm.isRequired("wjfs"),
                  rules: _vm.getRules("wjfs"),
                  name: "wjfs",
                  maxlength: "50",
                  autosize: "",
                  label: "文件份数",
                  placeholder: "请输入文件份数",
                  "input-align": "right",
                },
                model: {
                  value: _vm.formData.wjfs,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "wjfs", $$v)
                  },
                  expression: "formData.wjfs",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "yywjmc",
                    expression: "'yywjmc'",
                  },
                ],
                attrs: {
                  disabled: _vm.isDisabled("yywjmc"),
                  required: _vm.isRequired("yywjmc"),
                  name: "yywjmc",
                  rules: _vm.getRules("yywjmc"),
                  maxlength: "50",
                  autosize: "",
                  label: "用印文件名称",
                  placeholder: "请输入用印文件名称",
                  "input-align": "right",
                },
                model: {
                  value: _vm.formData.yywjmc,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "yywjmc", $$v)
                  },
                  expression: "formData.yywjmc",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "syhgsz",
                    expression: "'syhgsz'",
                  },
                ],
                attrs: {
                  "input-align": "right",
                  name: "syhgsz",
                  required: _vm.isRequired("syhgsz"),
                  value: _vm.formData.syhgsz,
                  label: "使用何公司章",
                  rules: _vm.getRules("syhgsz"),
                  placeholder: "请选择使用何公司章",
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("view-item", {
                          attrs: {
                            value: _vm.formData.syhgsz,
                            placeholder: "请选择使用何公司章",
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.isShowPopup(_vm.syhgsz, "syhgsz")
                            },
                          },
                        }),
                        _c(
                          "van-popup",
                          {
                            attrs: { position: "bottom" },
                            model: {
                              value: _vm.syhgsz.show,
                              callback: function ($$v) {
                                _vm.$set(_vm.syhgsz, "show", $$v)
                              },
                              expression: "syhgsz.show",
                            },
                          },
                          [
                            _c("van-nav-bar", {
                              attrs: {
                                title: "选择使用何公司章",
                                "left-text": "取消",
                                "right-text": "确定",
                              },
                              on: {
                                "click-left": function ($event) {
                                  _vm.syhgsz.show = false
                                },
                                "click-right": function ($event) {
                                  return _vm.popupSubmit("syhgsz")
                                },
                              },
                            }),
                            _c("van-search", {
                              attrs: { clearable: "", shape: "round" },
                              on: {
                                input: function ($event) {
                                  return _vm.pickerSearch($event, _vm.syhgsz)
                                },
                              },
                              model: {
                                value: _vm.syhgsz.filterText,
                                callback: function ($$v) {
                                  _vm.$set(_vm.syhgsz, "filterText", $$v)
                                },
                                expression: "syhgsz.filterText",
                              },
                            }),
                            _c("van-picker", {
                              ref: "syhgsz",
                              attrs: {
                                "value-key": "label",
                                columns: _vm.syhgsz.filteredData,
                              },
                              on: {
                                cancel: function ($event) {
                                  _vm.syhgsz.show = false
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "yzlx",
                    expression: "'yzlx'",
                  },
                ],
                attrs: {
                  "input-align": "right",
                  name: "yzlx",
                  type: "textarea",
                  maxlength: "200",
                  rows: "3",
                  required: _vm.isRequired("yzlx"),
                  disabled: _vm.isDisabled("yzlx"),
                  label: "印章类型",
                  rules: _vm.getRules("yzlx"),
                  placeholder: "请选择或输入印章类型",
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return undefined
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.formData.yzlx,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "yzlx", $$v)
                  },
                  expression: "formData.yzlx",
                },
              }),
              !_vm.isDisabled("yzlx")
                ? _c(
                    "div",
                    _vm._l(_vm.yzlx.filteredData, function (op, index) {
                      return _c(
                        "el-tag",
                        {
                          key: op,
                          staticStyle: {
                            "margin-left": "5px",
                            cursor: "pointer",
                            "font-size": "12px",
                            padding: "0 3px",
                            "line-height": "25px",
                            height: "25px",
                          },
                          attrs: { type: "info", size: "mini" },
                          on: {
                            click: function ($event) {
                              return _vm.handleClick(op)
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(op) + " ")]
                      )
                    }),
                    1
                  )
                : _vm._e(),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "ffwjyz",
                    expression: "'ffwjyz'",
                  },
                ],
                attrs: {
                  "input-align": "right",
                  name: "ffwjyz",
                  required: _vm.isRequired("ffwjyz"),
                  value: _vm.formData.ffwjyz,
                  label: "是否外借印章",
                  rules: _vm.getRules("ffwjyz"),
                  placeholder: "请选择是否外借印章",
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("view-item", {
                          attrs: {
                            value: _vm.formData.ffwjyz,
                            placeholder: "请选择是否外借印章",
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.isShowPopup(_vm.ffwjyz, "ffwjyz")
                            },
                          },
                        }),
                        _c(
                          "van-popup",
                          {
                            attrs: { position: "bottom" },
                            model: {
                              value: _vm.ffwjyz.show,
                              callback: function ($$v) {
                                _vm.$set(_vm.ffwjyz, "show", $$v)
                              },
                              expression: "ffwjyz.show",
                            },
                          },
                          [
                            _c("van-nav-bar", {
                              attrs: {
                                title: "选择是否外借印章",
                                "left-text": "取消",
                                "right-text": "确定",
                              },
                              on: {
                                "click-left": function ($event) {
                                  _vm.ffwjyz.show = false
                                },
                                "click-right": function ($event) {
                                  return _vm.popupSubmitFfwjyz("ffwjyz")
                                },
                              },
                            }),
                            _c("van-search", {
                              attrs: { clearable: "", shape: "round" },
                              on: {
                                input: function ($event) {
                                  return _vm.pickerSearch($event, _vm.ffwjyz)
                                },
                              },
                              model: {
                                value: _vm.ffwjyz.filterText,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ffwjyz, "filterText", $$v)
                                },
                                expression: "ffwjyz.filterText",
                              },
                            }),
                            _c("van-picker", {
                              ref: "ffwjyz",
                              attrs: {
                                "value-key": "label",
                                columns: _vm.ffwjyz.filteredData,
                              },
                              on: {
                                cancel: function ($event) {
                                  _vm.ffwjyz.show = false
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _vm.ffwjyzBool || _vm.formData.ffwjyz == "是"
                ? _c("van-field", {
                    directives: [
                      {
                        name: "f-show",
                        rawName: "v-f-show",
                        value: "ghrq",
                        expression: "'ghrq'",
                      },
                    ],
                    attrs: {
                      required: _vm.isRequired("ghrq"),
                      name: "ghrq",
                      label: "归还日期",
                      placeholder: "归还日期",
                      "input-align": "right",
                      rules: _vm.getRules("ghrq"),
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "input",
                          fn: function () {
                            return [
                              _c("view-item", {
                                attrs: {
                                  value: _vm.formData.ghrq,
                                  placeholder: "请选择归还日期",
                                },
                                nativeOn: {
                                  click: function ($event) {
                                    return _vm.isShowPopup(_vm.ghrq, "ghrq")
                                  },
                                },
                              }),
                              _c("van-calendar", {
                                ref: "ghrq",
                                attrs: {
                                  "min-date": _vm.minDate,
                                  "show-confirm": false,
                                  title: "选择归还日期",
                                },
                                on: { confirm: _vm.ghrqConfirm },
                                model: {
                                  value: _vm.ghrq.show,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.ghrq, "show", $$v)
                                  },
                                  expression: "ghrq.show",
                                },
                              }),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      2321138101
                    ),
                    model: {
                      value: _vm.formData.ghrq,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "ghrq", $$v)
                      },
                      expression: "formData.ghrq",
                    },
                  })
                : _vm._e(),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "ssxm",
                    expression: "'ssxm'",
                  },
                ],
                attrs: {
                  "input-align": "right",
                  name: "ssxm",
                  required: _vm.isRequired("ssxm"),
                  value: _vm.formData.ssxm,
                  rules: _vm.getRules("ssxm"),
                  label: "所属项目",
                  placeholder: "请选择项目",
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("view-item", {
                          attrs: {
                            value: _vm.formData.ssxm,
                            placeholder: "请选择项目",
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.isShowPopup(_vm.ssxm, "ssxm")
                            },
                          },
                        }),
                        _c(
                          "van-popup",
                          {
                            attrs: { position: "bottom" },
                            model: {
                              value: _vm.ssxm.show,
                              callback: function ($$v) {
                                _vm.$set(_vm.ssxm, "show", $$v)
                              },
                              expression: "ssxm.show",
                            },
                          },
                          [
                            _c("van-nav-bar", {
                              attrs: {
                                title: "选择项目",
                                "left-text": "取消",
                                "right-text": "确定",
                              },
                              on: {
                                "click-left": function ($event) {
                                  _vm.ssxm.show = false
                                },
                                "click-right": function ($event) {
                                  return _vm.popupSubmitSsxm("ssxm", {
                                    label: "projectName",
                                    value: "projectId",
                                  })
                                },
                              },
                            }),
                            _c(
                              "van-row",
                              {
                                staticClass: "p-r-20",
                                attrs: { type: "flex", align: "center" },
                              },
                              [
                                _c(
                                  "van-col",
                                  { attrs: { span: 18 } },
                                  [
                                    _c("van-search", {
                                      attrs: { clearable: "", shape: "round" },
                                      on: {
                                        input: function ($event) {
                                          return _vm.pickerSearch(
                                            $event,
                                            _vm.ssxm,
                                            "projectName"
                                          )
                                        },
                                      },
                                      model: {
                                        value: _vm.ssxm.filterText,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.ssxm, "filterText", $$v)
                                        },
                                        expression: "ssxm.filterText",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "van-col",
                                  { attrs: { span: 6 } },
                                  [
                                    _c(
                                      "van-button",
                                      {
                                        attrs: {
                                          loading: _vm.btnLoading,
                                          "loading-text": "加载中...",
                                          type: "primary",
                                          "native-type": "button",
                                          size: "small",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.selectMyProjectList(
                                              "",
                                              true
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("更多项目... ")]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c("van-picker", {
                              ref: "ssxm",
                              attrs: {
                                duration: 0,
                                "value-key": "projectName",
                                columns: _vm.ssxm.filteredData,
                              },
                              on: {
                                cancel: function ($event) {
                                  _vm.ssxm.show = false
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "bz",
                    expression: "'bz'",
                  },
                ],
                attrs: {
                  readonly: _vm.isDisabled("bz"),
                  required: _vm.isRequired("bz"),
                  name: "bz",
                  rules: _vm.getRules("bz"),
                  type: "textarea",
                  maxlength: "200",
                  rows: "3",
                  autosize: "",
                  label: "备注",
                  "show-word-limit": "",
                  placeholder: "请输入备注",
                  "input-align": "right",
                },
                model: {
                  value: _vm.formData.bz,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "bz", $$v)
                  },
                  expression: "formData.bz",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "fj",
                    expression: "'fj'",
                  },
                ],
                staticClass: "fileValueBox",
                attrs: {
                  "input-align": "right",
                  name: "fj",
                  required: _vm.isRequired("fj"),
                  rules: _vm.getRules("fj"),
                  label: "附件",
                  placeholder: "请上传文件",
                },
                domProps: { value: _vm.formData.fj },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("uploadFiles", {
                          attrs: {
                            disabled: _vm.isDisabled("fj"),
                            files: _vm.formData.fj,
                            "module-type": "flow",
                          },
                          on: {
                            success: _vm.uploadSuccess,
                            fileRemove: (removedFile) =>
                              _vm.handleFileRemove(
                                removedFile,
                                "formData",
                                "fj"
                              ),
                          },
                        }),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "font-32 font-weight-500 cor-00 m-t-26" }, [
        _vm._v("流程"),
      ]),
      !_vm.$route.query.reSend &&
      (_vm.processInstanceId || _vm.$route.query.processInstanceId)
        ? _c("flowTrace", {
            staticClass: "m-t-20",
            attrs: {
              flowTraceList: _vm.flowTrace,
              processInfo: _vm.processData,
            },
          })
        : _c("approver", {
            ref: "approver",
            staticClass: "m-t-20",
            attrs: {
              processData: _vm.processData,
              formData: _vm.formData,
              formItemMap: _vm.formItemMap,
            },
            on: { addUser: _vm.addUser },
          }),
      _c("bottom-bar", { on: { submit: _vm.submit, mention: _vm.mention } }),
      _c(
        "van-popup",
        {
          attrs: { position: "bottom" },
          model: {
            value: _vm.approver.show,
            callback: function ($$v) {
              _vm.$set(_vm.approver, "show", $$v)
            },
            expression: "approver.show",
          },
        },
        [
          _c("van-nav-bar", {
            attrs: {
              title: "选择办理人",
              "left-text": "取消",
              "right-text": "确定",
            },
            on: {
              "click-left": function ($event) {
                _vm.approver.show = false
              },
              "click-right": _vm.approverPopupSubmit,
            },
          }),
          _c("van-search", {
            attrs: { clearable: "", shape: "round" },
            on: {
              input: function ($event) {
                return _vm.treeSearch($event, _vm.$refs.approverTree)
              },
            },
            model: {
              value: _vm.approver.filterText,
              callback: function ($$v) {
                _vm.$set(_vm.approver, "filterText", $$v)
              },
              expression: "approver.filterText",
            },
          }),
          _c(
            "div",
            { staticClass: "h-vh-50", staticStyle: { "overflow-y": "auto" } },
            [
              _c(
                "div",
                { staticClass: "p-10" },
                [
                  _c("el-tree", {
                    ref: "approverTree",
                    attrs: {
                      "node-key": "uuid",
                      "check-strictly": "",
                      data: _vm.approver.data,
                      "filter-node-method": _vm.filterNode,
                      "check-on-click-node": "",
                      "show-checkbox": "",
                    },
                    on: {
                      "check-change": function ($event) {
                        return _vm.approverCheckChange(
                          $event,
                          _vm.$refs.approverTree
                        )
                      },
                    },
                  }),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }